// extracted by mini-css-extract-plugin
module.exports = {"revSettle-table-wrapper":"revSettle_revSettle-table-wrapper__34zkq","revSettle-table":"revSettle_revSettle-table__1rEPZ"};